import * as React from 'react';
import Page from '../../../components/Page';
import SettingsContainer from '../container/SettingsContainer';

const SettingsPage = () => (
  <Page header="settings" inPanel={false}>
    <SettingsContainer />
  </Page>
);

export default SettingsPage;
